import NewMobileMain from "./NewMobileMain";

export const OnboardingMobile = ({ data = {} }) => {
    const hasDashboardData = Boolean(
        data.isLoaded &&
        data.item &&
        data.item.loan_aggregate &&
        data.item.student_loan_info &&
        data.item.paidoff_loans &&
        data.userInfo
    );

    if (hasDashboardData) {
        return <NewMobileMain data={data} />;
    }

    return (
        <div className="onboarding-mobile">
            <div className="body-content">
                {data.error
                    ? "We do not have any Student Loan information to display."
                    : "Loading..."}
            </div>
        </div>
    );
};
